import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useState } from 'react';
import { ADD_TO_WISHLIST, REMOVE_FROM_WISHLIST, store } from '../state/state';
import Icon from './Icon';
const AddToWishlist = ({ id }) => {
    const globalState = useContext(store);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { state, dispatch } = globalState;
    const [isActive, setIsActive] = useState(state.wishlist.includes(id.toString()));
    const onClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (isActive) {
            dispatch({
                type: REMOVE_FROM_WISHLIST,
                id: id.toString()
            });
            setIsActive(false);
        }
        else {
            dispatch({
                type: ADD_TO_WISHLIST,
                id: id.toString()
            });
            setIsActive(true);
        }
    };
    return (_jsx("button", { type: "button", "aria-label": "Add to wishlist", onClick: (e) => onClick(e), className: `add-to-favourite w-6 h-6 flex-none ${isActive ? 'text-green-700 is-active' : 'text-grey-200'} hover:animate-heartbeat`, role: "button", children: _jsx(Icon, { name: `${isActive ? 'heart-full' : 'heart'}` }) }));
};
export default AddToWishlist;
